import React from "react";

import Badge from "@/components/UI/Badge";
import CardSecondary from "@/components/UI/Card/CardSecondary";

export const ExpandingTextArea = (props) => {
  let [expand, setExpand] = React.useState(false);

  return (
    <CardSecondary className="p-3 m-3" style={{ height: expand ? "95%" : "25%" }}>
      <p className="tw:font-bold">{props.label}</p>
      <textarea
        className="w-100"
        onChange={props.onChange}
        style={{ height: !expand ? "60%" : "90%", maxHeight: "90%", resize: "none" }}
        value={props.value}
        {...props.textareaProps}
      />
      <div>
        <Badge
          classes="m-auto"
          onClick={() => setExpand(!expand)}
          text={!expand ? "Expand" : "Collapse"}
          type="light-grey"
        />
      </div>
    </CardSecondary>
  );
};
